import { Grid, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

import { Button } from "../../../../../../components/Form";

export const GridWithAfterRowWrapper = styled("div")(() => ({
  "& .MuiTableContainer-root": {
    overflowY: "hidden",
    overflowX: "hidden",
  },
  "& .MuiTableBody-root tr.MuiTableRow-root:nth-child(odd)": {
    backgroundColor: "unset !important",
  },
  "& > div > div > div > table > tbody > tr": {
    backgroundColor: "#fff !important",
    "&:not(:last-child)": {
      borderBottom: "1px solid rgba(237, 245, 251, 1) !important",
    },
  },
  "& .MuiFormControl-root > span": {
    display: "none",
  },
}));

export const GridActionContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: 4,
}));

interface GridActionItemContainerProps {
  active?: boolean;
}
export const GridActionItemContainer = styled("span")(
  ({ active }: GridActionItemContainerProps) => ({
    borderRadius: "50%",
    cursor: "pointer",
    backgroundColor: active ? colors.gray200 : "transparent",
    width: "24px",
    height: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  })
);

export const DownloadButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
}));

export const EmptyDiv = styled("div")(() => ({
  border: "1px solid #eaebef",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  borderRadius: "5px",
  textAlign: "center",
  minHeight: "calc(100vh - 390px)",
}));

export const RightActionsGrid = styled(Grid)(() => ({
  width: "max-content",
}));

export const LeftActionsGrid = styled(Grid)(() => ({
  minWidth: "240px",
}));

export const ExportCSVButton = styled(Button)(() => ({
  width: 135,
}));

export const OpenSubscriptionDrawIconButton = styled(IconButton)(() => ({
  borderRadius: "8px !important",
  borderColor: `${colors.brandBlue500} !important`,
  borderWidth: "1px !important",
  borderStyle: "solid !important",
  padding: "8px !important",
  "&:hover": {
    backgroundColor: "#0055A414 !important",
  },
}));
